import {
  ICON_DEFAULT_COLOR,
  ICON_DEFAULT_FILL,
  ICON_DEFAULT_HEIGHT,
  ICON_DEFAULT_VIEWBOX,
  ICON_DEFAULT_WIDTH,
  IconProps
} from 'components'
import { ComponentProps } from 'react'

export const TrendingUp = ({
  color = ICON_DEFAULT_COLOR,
  fill = ICON_DEFAULT_FILL,
  width = ICON_DEFAULT_WIDTH,
  height = ICON_DEFAULT_HEIGHT,
  viewBox = ICON_DEFAULT_VIEWBOX,
  ...props
}: ComponentProps<'svg'> & Omit<IconProps, 'icon'>) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M34.519 11.7495C33.5096 11.7495 32.6913 12.5678 32.6913 13.5772C32.6913 14.5866 33.5096 15.4048 34.519 15.4048H41.5298L27.8559 29.0788L19.6291 20.852C18.9154 20.1383 17.7582 20.1383 17.0444 20.852L2.76578 35.1307C2.05203 35.8444 2.05203 37.0016 2.76578 37.7154C3.47953 38.4291 4.63674 38.4291 5.35049 37.7154L18.3368 24.7291L26.5635 32.9558C27.2773 33.6696 28.4345 33.6696 29.1483 32.9558L44.1142 17.9899V25.0001C44.1142 26.0095 44.9325 26.8278 45.9419 26.8278C46.9513 26.8278 47.7696 26.0095 47.7696 25.0001V13.6104C47.7782 13.1317 47.5999 12.6502 47.2345 12.2848C47.0271 12.0774 46.7822 11.9302 46.5217 11.8434C46.3395 11.7825 46.1445 11.7495 45.9419 11.7495H34.519Z"
        fill={color}
      />
    </svg>
  )
}
